module.exports = __webpack_public_path__ + "media/images/sp/specials/fair_event/gallery/tmb_gallery11-70305df6b16d02bd02bbfb93460c25f8.jpg";